import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.9362 4.9088C14.1628 4.66706 14.1506 4.28736 13.9088 4.06072C13.6671 3.83408 13.2874 3.84633 13.0607 4.08807L6.01378 11.6048L2.94999 8.10334C2.73178 7.85395 2.35272 7.82868 2.10334 8.04689C1.85396 8.2651 1.82869 8.64416 2.0469 8.89354L5.5469 12.8935C5.65847 13.021 5.81875 13.0954 5.98815 13.0984C6.15755 13.1013 6.32029 13.0324 6.43617 12.9088L13.9362 4.9088Z"
	})
});
export default SvgCheckmark;
